__webpack_require__.p = "/pt/semana-do-consumidor/";